<template>
  <div class="container">
    <Exp-header />
    <div class="main">
      <router-view></router-view>
    </div>
    <div class="footer">
      ©copyright    华侨大学建筑学院虚拟仿真实验申报管理平台
    </div>
  </div>
</template>

<script>
import ExpHeader from '@/components/experiment/expHeader.vue'
export default {
  name: 'experiment',
  components: { ExpHeader }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .main {
    width: 100%;
    padding: 50px 18%;
  }
  .footer {
    width: 100%;
    height: 53px;
    background-color: #edf2f6;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media only screen and (max-width: 1024px) {
  .container {
    .main {
      padding: 50px 5%;
    }
  }
}
</style>